// Copyright 2022-2024, 2026 - Hewlett Packard Enterprise Company
import { useState, useContext } from 'react';
import { Box, Button, Anchor } from 'grommet';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getServer } from '../../actions/Api';
import DeviceDisabledModal from '../DeviceDisabledModal/DeviceDisabledModal';
import TextEmphasis from '../TextEmphasis/TextEmphasis';
import { showDeviceDisabledModal, isOvServer } from '../../utils/apiHelpers';
import { AuthContext } from '../../contexts/AuthContext';

export default function DeviceDetailsLink({
  deviceId,
  device,
  name,
  tenantAcid,
  handleError,
  useButton,
}) {
  const [disabledOpen, setDisabledOpen] = useState(false);
  const [disabledDevice, setDisabledDevice] = useState();
  const history = useHistory();
  const { updateTenantAcid } = useContext(AuthContext);
  const serverDetailUrlPrefix = '/serverDetail/';
  const ovServerDetailUrlPrefix = '/hardwareDetail/';

  const openDisabledModal = device => {
    setDisabledDevice(device);
    setDisabledOpen(true);
  };

  const updateTenantAndRedirect = (tenantAcid, route) => {
    tenantAcid && updateTenantAcid(tenantAcid);
    history.push(route);
  };

  const onClickServerLink = async (deviceId, handleError) => {
    let server;
    if (!server && deviceId) {
      const resp = await getServer(deviceId, tenantAcid).catch(error => {
        if (error.response?.status === 404) {
          // Show a disabled modal if the server
          // is no longer managed by COM
          server = {
            healthSummary_: 'DISABLED',
            serverState_: 'Not assigned',
          };
        } else {
          handleError(error);
        }
      });
      if (resp) server = resp.data;
    }

    if (server) {
      const serverDetailsRoute = isOvServer(server)
        ? `${ovServerDetailUrlPrefix}${server.appliance_?.id}/${server?.id}`
        : `${serverDetailUrlPrefix}${server?.id}`;
      showDeviceDisabledModal(server)
        ? openDisabledModal(server)
        : updateTenantAndRedirect(tenantAcid, serverDetailsRoute);
    }
  };

  return (
    <Box>
      {useButton ? (
        <Button
          onClick={() => {
            onClickServerLink(deviceId, handleError);
          }}
        >
          <Box>
            <TextEmphasis truncate="tip">{name}</TextEmphasis>
          </Box>
        </Button>
      ) : (
        <Anchor
          label={name}
          onClick={() => {
            onClickServerLink(deviceId, handleError);
          }}
        />
      )}
      {disabledOpen && (
        <DeviceDisabledModal
          data={disabledDevice}
          onClose={() => {
            setDisabledOpen(false);
          }}
        />
      )}
    </Box>
  );
}

DeviceDetailsLink.propTypes = {
  deviceId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  tenantAcid: PropTypes.string,
  handleError: PropTypes.func.isRequired,
};
